import script from "./RequestCloseReasonsView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestCloseReasonsView.vue?vue&type=script&setup=true&lang=js"

import "./RequestCloseReasonsView.vue?vue&type=style&index=0&id=11c32920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c32920"]])

export default __exports__